<template>
  <nav class="footer__auth column">
    <h4>{{ t('footer_03') }}</h4>

    <a
      :href="`https://app.arcticreply.com/auth/register?language=${$store.state.language}&campaign=${$store.state.campaign}`"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="fa-solid fa-user-plus"></i>
      <span>{{ t('footer_04') }} </span>
    </a>
    <a
      :href="`https://app.arcticreply.com/auth/login?language=${$store.state.language}&campaign=${$store.state.campaign}`"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i class="fa-solid fa-right-to-bracket"></i>
      <span>{{ t('footer_05') }}</span>
    </a>
  </nav>
</template>

<style lang="scss" scoped>
@import '../styles.scss';
</style>
